import type { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import type { GenericError, RequestStatus, WsMessagePayload } from '@skynet/data-ws-core';

export enum ExchangeCommands {
  Exchanges = 'Exchanges',
}

export interface JsonExchange {
  id: number;
  name: string;
  ticker: string;
}

export interface JsonExchangesListSuccess {
  command: ExchangeCommands.Exchanges;

  list: Array<{
    ID: number;
    Name: string;
    Ticker: string;
    BotName: string;
    PublicLength: number;
    /*
    // The following fields exist but we don't rely on them
    SecretLength: number;
    PublicMask: string;
    SecretMask: string;
    IPs: string;
    VideoURL: string;
    LogoURL: string;
    Type: number;
    Status: number;
    Crypted: boolean;
    Passphrase: boolean;
    PassphraseNumbersOnly: boolean;
    PassphraseLabel: string; */
  }>;
}

export interface ExchangesState {
  requestStatus: RequestStatus;
  error: null | GenericError;

  list: JsonExchange[];
}

/**
 * Props for {@link initExchangeSlice}. The slice is channel-agnostic: the
 * caller supplies the WebSocket message action creator (`messages`) for the
 * channel it is mounted on (e.g. MM or ES), and where the reducer is mounted
 * in the store is decided by the app, not by this package.
 */
export interface ExchangeSliceFactoryProps {
  /** Prefix used for the generated slice name (`${prefix}/${sliceName}`). */
  prefix?: string;
  /** Slice name suffix used for the generated slice name. */
  sliceName?: string;
  /** Commands this slice reacts to. Defaults to {@link ExchangeCommands}. */
  commands?: typeof ExchangeCommands;
  /** WebSocket "on message" action creator for the channel this slice serves. */
  messages: ActionCreatorWithPayload<WsMessagePayload>;
  /** Initial slice state. */
  initialState: ExchangesState;
}
